@if (workCenter$ | async; as workCenter) {
  @if (itemConstraints$ | async; as itemConstraints) {
    <div class="layout-col full bg-background">
      <mat-toolbar elderTheme>
        <div class="flex layout-row place-end-center gap-sm">
          <button mat-icon-button matDialogClose="">
            <mat-icon>close</mat-icon>
          </button>
          <elder-header
            [header]="('shopfloor.workcenters.workcenter' | translate) + ': ' + workCenter?.name"
            [subheader]="workCenter.number"
          >
          </elder-header>
          <span class="flex"></span>
          @switch (data.viewMode) {
            @case (ViewMode.PREVIEW) {
              <span class="text-title-large">{{ data.scheduleInterval | isoInterval }}</span>
            }
            @case (ViewMode.LIVE) {
              <span class="text-title-large">{{ currentTime | date: 'medium' }}</span>
            }
          }
          <span class="flex"></span>
          <button
            mat-icon-button
            [disabled]="!hasItemConstraints(itemConstraints)"
            (click)="onOpenItemConstraints(itemConstraints)"
            [matBadge]="numberOfActiveItemConstraints(itemConstraints)"
            [matBadgeHidden]="numberOfActiveItemConstraints(itemConstraints) === 0"
            [matBadgeColor]="'warn'"
            [matBadgeOverlap]="true"
          >
            <mat-icon>filter_list</mat-icon>
          </button>
          <button mat-icon-button (click)="onProductionListRequested(workCenter)">
            <mat-icon>assignment</mat-icon>
          </button>
          <button mat-icon-button (click)="openTerminal(workCenter, data.scheduleInterval)">
            <mat-icon>open_in_browser</mat-icon>
          </button>
        </div>
      </mat-toolbar>
      <app-work-center-utilisation-detail
        class="flex"
        [workCenter]="workCenter"
        [scheduleInterval]="data.scheduleInterval"
        [viewMode]="data.viewMode"
        [itemConstraints]="itemConstraints"
      ></app-work-center-utilisation-detail>
    </div>
  }
}
